// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Js_option from "rescript/lib/es6/js_option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as GraphQLFetchClient$LiveRoom from "./GraphQLFetchClient.bs.js";
import * as ClientApiBaseClient$LiveRoom from "./ClientApiBaseClient.bs.js";

var ppx_printed_query = "query IDDocumentSummary  {\nme  {\nidentityDocumentSummary  {\nreason  \nuploadRequired  \n}\n\n}\n\n}\n";

function parse(value) {
  var value$1 = Js_option.getExn(Js_json.decodeObject(value));
  var value$2 = Js_dict.get(value$1, "me");
  var tmp;
  if (value$2 !== undefined) {
    var value$3 = Js_option.getExn(Js_json.decodeObject(Caml_option.valFromOption(value$2)));
    var value$4 = Js_dict.get(value$3, "identityDocumentSummary");
    var tmp$1;
    if (value$4 !== undefined) {
      var value$5 = Caml_option.valFromOption(value$4);
      var match = Js_json.decodeNull(value$5);
      if (match !== undefined) {
        tmp$1 = undefined;
      } else {
        var value$6 = Js_option.getExn(Js_json.decodeObject(value$5));
        var value$7 = Js_dict.get(value$6, "reason");
        var tmp$2;
        if (value$7 !== undefined) {
          var value$8 = Caml_option.valFromOption(value$7);
          var match$1 = Js_json.decodeNull(value$8);
          if (match$1 !== undefined) {
            tmp$2 = undefined;
          } else {
            var value$9 = Js_json.decodeString(value$8);
            var tmp$3;
            if (value$9 !== undefined) {
              switch (value$9) {
                case "ID_EXPIRED" :
                    tmp$3 = "ID_EXPIRED";
                    break;
                case "ID_NEEDS_REVIEW" :
                    tmp$3 = "ID_NEEDS_REVIEW";
                    break;
                case "ID_REJECTED" :
                    tmp$3 = "ID_REJECTED";
                    break;
                case "NO_ID" :
                    tmp$3 = "NO_ID";
                    break;
                case "NO_REASON" :
                    tmp$3 = "NO_REASON";
                    break;
                default:
                  tmp$3 = Js_exn.raiseError("graphql_ppx: Unknown enum variant for IdentityDocumentReason: " + value$9);
              }
            } else {
              tmp$3 = Js_exn.raiseError("graphql_ppx: Expected enum value for IdentityDocumentReason, got " + JSON.stringify(value$8));
            }
            tmp$2 = tmp$3;
          }
        } else {
          tmp$2 = undefined;
        }
        var value$10 = Js_dict.get(value$6, "uploadRequired");
        var tmp$4;
        if (value$10 !== undefined) {
          var value$11 = Caml_option.valFromOption(value$10);
          var value$12 = Js_json.decodeBoolean(value$11);
          tmp$4 = value$12 !== undefined ? value$12 : Js_exn.raiseError("graphql_ppx: Expected boolean, got " + JSON.stringify(value$11));
        } else {
          tmp$4 = Js_exn.raiseError("graphql_ppx: Field uploadRequired on type IdentityDocumentSummary is missing");
        }
        tmp$1 = {
          reason: tmp$2,
          uploadRequired: tmp$4
        };
      }
    } else {
      tmp$1 = undefined;
    }
    tmp = {
      identityDocumentSummary: tmp$1
    };
  } else {
    tmp = Js_exn.raiseError("graphql_ppx: Field me on type Query is missing");
  }
  return {
          me: tmp
        };
}

function make(param) {
  return {
          query: ppx_printed_query,
          variables: null,
          parse: parse
        };
}

function makeWithVariables(param) {
  return {
          query: ppx_printed_query,
          variables: null,
          parse: parse
        };
}

function makeVariables(param) {
  return null;
}

function definition_2(graphql_ppx_use_json_variables_fn) {
  return 0;
}

var definition = [
  parse,
  ppx_printed_query,
  definition_2
];

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var LiveRoomGraphQL = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  make: make,
  makeWithVariables: makeWithVariables,
  makeVariables: makeVariables,
  definition: definition,
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

var Query = GraphQLFetchClient$LiveRoom.MakeQuery(ClientApiBaseClient$LiveRoom.Make({
          query: ppx_printed_query,
          parse: parse
        }));

var UserIdSummary = {
  LiveRoomGraphQL: LiveRoomGraphQL,
  Query: Query
};

var Queries = {
  UserIdSummary: UserIdSummary
};

var Clientapi = {
  Queries: Queries
};

export {
  Clientapi ,
}
/* Query Not a pure module */
